module.exports = __webpack_public_path__ + "u2.no2.946f1d0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/u2.no2.jpg
// module id = I+tE
// module chunks = 0